<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1 class="h1">Previsió Facturació</h1>
      </b-col>
      <b-col class="col text-right">
        <h2>Mes: {{ getActualMonth() }}</h2>
      </b-col>
    </b-row>
    <table class="table table-striped">
      <thead>
        <tr></tr>
      </thead>
      <tbody>
        <template v-for="item in facturas">
          <tr>
            <th scope="row">{{ item.cliente.nombre }}</th>
            <th></th>
            <th></th>
            <th>IMPORT BASE</th>
            <th>IVA %</th>
            <th>IMPORT IVA</th>
            <th>TOTAL FACTURA</th>
          </tr>
          <tr>
            <td></td>
            <th></th>
            <th></th>
            <td>{{ item.precioBase.toFixed(2) }}</td>
            <td>{{ item.cliente.tipoIVA }} %</td>
            <td>{{ item.impuestoIVA.toFixed(2) }}</td>
            <td>{{ item.totalFactura.toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Producte</td>
            <td>Cantitat</td>
            <td>Preu</td>
            <td>P. Base</td>
            <td>Dte %</td>
            <td>Dte €</td>
            <td>Preu Linea</td>
          </tr>
          <tr v-for="fd in item.facturaDetalles" :key="fd.identifier">
            <td>{{ fd.producte }}</td>
            <td>{{ fd.cantidad }}</td>
            <td>{{ fd.productoPrecio }}</td>
            <td>{{ fd.precioBase }}</td>
            <td>{{ fd.productoDescuento }}</td>
            <td>{{ fd.precioBase - fd.precioLinea }}</td>
            <td>{{ fd.precioLinea }}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>BASE TOTAL</th>
          <th>IVA</th>
          <th>TOTAL</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            {{ facturas.reduce((a, c) => a + c.precioBase, 0).toFixed(2) }}
          </td>
          <td>
            {{ facturas.reduce((a, c) => a + c.impuestoIVA, 0).toFixed(2) }}
          </td>
          <td>
            {{ facturas.reduce((a, c) => a + c.totalFactura, 0).toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>
  </b-container>
</template>

<script>
  import DataAccess from "@/Services/DataAccess.js";
  import moment from "moment";

  export default {
    data() {
      return {
        facturas: [],
      };
    },
    created() {
      (async () => {
        var url = "/api/facturas";
        await DataAccess.getData(url)
          .then((response) => {
            this.facturas = response.data;
            this.totalRows = this.facturas.length;
            this.loading = false;
          })
          .catch((error) => {
            console.log("ERROR: ", error);
          });
      })();
    },
    methods: {
      getActualMonth() {
        var date = Date();
        return moment(date).add(1, "months").locale("es").format("MMMM");
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
